__webpack_require__.p = "/luminarycloud-v1/";